// Stand-ins for the 2023 array methods toReversed, toSorted and with. Older
// browsers lack them (before Chrome 110 and Safari 16: Chromebooks past their
// last update, older iPhones), and the game stopped dead there on its first
// table. src/tsconfig.json leaves the methods out, so they do not compile.
// Each makes a new array; what it was handed stays as it was.

export const reversed = <T>(xs: readonly T[]): readonly T[] => [...xs].reverse()

export const sorted = (xs: readonly string[]): readonly string[] => [...xs].sort()

export const replaced = <T>(xs: readonly T[], i: number, x: T): readonly T[] => xs.map((y, j) => (j === i ? x : y))
